import { createQueryClient } from '@alascorporation/utils';

export const queryClient = createQueryClient();
